<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Contents</h1>
<h2 class="TOC-FBMHD"><a href="#/int">Introduction</a></h2>
<h2 class="TOC-CH-T"><a href="#/c01">Essential Equipment</a></h2>
<h2 class="TOC-CH-T"><a href="#/c02">General Techniques</a></h2>
<h2 class="TOC-CH-T"><span href="#/c03" title="Link target outside of Sample">Finishing Techniques</span></h2>
<h2 class="TOC-CH-T"><span href="#/c04" title="Link target outside of Sample">Knotting</span></h2>
<p class="TOC-AHD"><span href="#/c05" title="Link target outside of Sample">Knotting Basics</span></p>
<p class="TOC-CH-AU"><span href="#/c06" title="Link target outside of Sample">Individual Knots</span></p>
<p class="TOC-AHD"><span href="#/c06#Basic-Knots" title="Link target outside of Sample">Basic Knots</span></p>
<p class="TOC-AHD"><span href="#/c06#Chinese-Knots" title="Link target outside of Sample">Chinese Knots</span></p>
<p class="TOC-AHD"><span href="#/c06#Flower-Knots" title="Link target outside of Sample">Flower Knots</span></p>
<p class="TOC-AHD"><span href="#/c06#Ring-Knots" title="Link target outside of Sample">Ring Knots</span></p>
<p class="TOC-CH-AU"><span href="#/c07" title="Link target outside of Sample">Knotted Braids</span></p>
<p class="TOC-AHD"><span href="#/c07#Basic-Knotted-Braids" title="Link target outside of Sample">Basic Knotted Braids</span></p>
<p class="TOC-AHD"><span href="#/c07#Switchback-Braids" title="Link target outside of Sample">Switchback Braids</span></p>
<p class="TOC-AHD"><span href="#/c07#Slip-Knot-Braids" title="Link target outside of Sample">Slip Knot Braids</span></p>
<p class="TOC-AHD"><span href="#/c07#Box-Braids" title="Link target outside of Sample">Box Braids</span></p>
<p class="TOC-AHD"><span href="#/c07#Beaded-Knotted-Braids" title="Link target outside of Sample">Beaded Knotted Braids</span></p>
<p class="TOC-CH-AU"><span href="#/c08" title="Link target outside of Sample">Macramé</span></p>
<p class="TOC-AHD"><span href="#/c08#Macram--Basics" title="Link target outside of Sample">Macramé Basics</span></p>
<p class="TOC-AHD"><span href="#/c08#Square-Knot-Variations" title="Link target outside of Sample">Square Knot Variations</span></p>
<p class="TOC-AHD"><span href="#/c08#Multistrand-Macram-" title="Link target outside of Sample">Multistrand Macramé</span></p>
<p class="TOC-AHD"><span href="#/c08#Half-hitch-Variations" title="Link target outside of Sample">Half-hitch Variations</span></p>
<p class="TOC-AHD"><span href="#/c08#Adding-Beads-to-Macram-" title="Link target outside of Sample">Adding Beads to Macramé</span></p>
<p class="TOC-AHD"><span href="#/c08#Finishing-Techniques-for-Knotting" title="Link target outside of Sample">Finishing Techniques for Knotting</span></p>
<h2 class="TOC-CH-T"><span href="#/c09" title="Link target outside of Sample">Braiding</span></h2>
<p class="TOC-CH-AU"><span href="#/c10" title="Link target outside of Sample">Plaiting</span></p>
<p class="TOC-AHD"><span href="#/c10#Plaiting-with-Beads-and-Chain" title="Link target outside of Sample">Plaiting with Beads and Chain</span></p>
<p class="TOC-CH-AU"><span href="#/c11" title="Link target outside of Sample">Kumihimo</span></p>
<p class="TOC-AHD"><span href="#/c11#Equipment-and-Materials" title="Link target outside of Sample">Equipment and Materials</span></p>
<p class="TOC-AHD"><span href="#/c11#Preparing-to-Braid" title="Link target outside of Sample">Preparing to Braid</span></p>
<p class="TOC-AHD"><span href="#/c11#Basic-Moves" title="Link target outside of Sample">Basic Moves</span></p>
<p class="TOC-AHD"><span href="#/c11#Round-Braids" title="Link target outside of Sample">Round Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Helix-Spiral-Braids" title="Link target outside of Sample">Helix Spiral Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Hollow-Braids" title="Link target outside of Sample">Hollow Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Flat-Braids" title="Link target outside of Sample">Flat Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Woven-Flat-Braids" title="Link target outside of Sample">Woven Flat Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Beaded-Kumihimo-Braids" title="Link target outside of Sample">Beaded Kumihimo Braids</span></p>
<p class="TOC-AHD"><span href="#/c11#Working-with-Wire" title="Link target outside of Sample">Working with Wire</span></p>
<p class="TOC-AHD"><span href="#/c11#Finishing-Techniques-for-Braiding" title="Link target outside of Sample">Finishing Techniques for Braiding</span></p>
<h2 class="TOC-CH-T"><span href="#/pro" title="Link target outside of Sample">Projects</span></h2>
<h2 class="TOC-FBMHD"><span href="#/sup" title="Link target outside of Sample">Suppliers</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="TOC-FBMHD"><span href="#/cop" title="Link target outside of Sample">Copyright</span></h2>
<h2 class="TOC-FBMHD" id="templates"><em>All full-size templates can be found at</em> <a href="http://www.stitchcraftcreate.co.uk/patterns" target="_blank">www.stitchcraftcreate.co.uk/patterns</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?278f38a4